import { ContractTemplate, ParameterTypeEnum, PayrollParameters } from '@akiba/models_beta_temp';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-template-modal',
  templateUrl: './create-template-modal.component.html',
  styleUrls: ['./create-template-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateTemplateModalComponent implements OnInit {

  template: ContractTemplate = new ContractTemplate();
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  procType(): void {

    const date = new Date();
    this.template = new ContractTemplate();
    this.template.templateID = date.getTime().toString();

  }

  createdParameter(): void {
    this.activeModal.close(this.template);
  }

}
